import { render } from "./IndicatorCard.vue?vue&type=template&id=019961a8&scoped=true&ts=true"
import script from "./IndicatorCard.vue?vue&type=script&lang=ts"
export * from "./IndicatorCard.vue?vue&type=script&lang=ts"

import "./IndicatorCard.vue?vue&type=style&index=0&id=019961a8&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019961a8"]])

export default __exports__